import Modal from '@mui/material/Modal';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import { getHeaders } from '../../../../utils';
import {
  getProfilePublicId,
  getUserPublicId,
} from '../../../../utils/authUtils';
import { instance } from '../../../axios/axios';
import {
  getCurrentUserRegistered,
  setPsychoQuizModal,
  setQuizModal,
} from '../../../store/slices/community/loveSlice';
import Loader from '../../Common/Loader/Loader';

const MdClear = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdClear)
);
const MdClose = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdClose)
);

const QuizModal = () => {
  const lang = useSelector(({ common }) => common?.language);
  const router = useRouter();
  const { city } = router.query;
  const dispatch = useDispatch();
  const quizModal = useSelector(({ love }) => love?.quizModal);
  const psychoQuizModal = useSelector(({ love }) => love?.psychoQuizModal);
  const loveProfile = useSelector(({ love }) => love?.isCurrentUserRegistered);
  const [quizData, setQuizData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disableQuizSubmit, setDisableQuizSubmit] = useState(true);
  function getCityId() {
    return loveProfile?.city_id || null;
  }
  async function getGenericQuiz() {
    try {
      setLoading(true);
      const res = await instance.get(
        `/forum/love/local-quiz-questions?req_city_id=${getCityId()}`,
        getHeaders()
      );

      setQuizData(res?.data);
      setLoading(false);
    } catch (err) {
      console.error('Something went wrong', err);
      setLoading(false);
    }
  }

  async function getPsychoQuiz() {
    try {
      setLoading(true);
      const res = await instance.get(
        `/forum/love/all-city-quiz-questions?req_city_id=${getCityId()}`,
        getHeaders()
      );

      setQuizData(res?.data);
      setLoading(false);
    } catch (err) {
      console.error('Something went wrong', err);
      setLoading(false);
    }
  }

  const [index, setIndex] = useState(0);

  let submitData = {
    user_id: loveProfile?.user_id,
    profile_id: loveProfile?.profile_id,
    answers: [],
  };

  const updateIndex = () => {
    if (index >= 0 && index < quizData?.length - 1) {
      setIndex((prev) => ++prev);
    }
  };

  const handleCancel = () => {
    reset();
  };

  const handleBack = () => {
    if (showBackArrow()) {
      setIndex((prev) => --prev);
    }
  };

  function showBackArrow() {
    return index > 0 && index <= quizData?.length - 1;
  }

  function showSubmit() {
    return index === quizData?.length - 1;
  }

  const existing_data = JSON.parse(localStorage.getItem('answerData')) || [];

  const onChange = (e) => {
    const answer = {};
    let shouldUpdate = false;
    answer['question_id'] = quizData[index]?.id;
    answer['option_id'] = e.target.value;

    for (const item of existing_data) {
      if (item?.question_id === quizData[index]?.id) {
        item['option_id'] = e.target.value;
        shouldUpdate = true;
      }
    }
    if (!shouldUpdate) existing_data.push(answer);

    localStorage.setItem('answerData', JSON.stringify(existing_data));

    setDisableQuizSubmit(false);
  };

  const handleSubmit = async () => {
    submitData['answers'] = existing_data;

    if (submitData['answers']?.length === 0) return;

    if (quizModal) {
      await instance.post(
        '/forum/love/local-quiz-submit',
        submitData,
        getHeaders()
      );
    } else if (psychoQuizModal) {
      await instance.post(
        '/forum/love/all-city-quiz-submit',
        submitData,
        getHeaders()
      );
    }

    if (router.pathname !== '/community/categories/[categoryId]') {
      router.push({
        pathname: '/community/categories/15',
        query: { city: city },
      });
    } else if (router.pathname === '/community/categories/[categoryId]') {
      // dispatch(getPreferredUsers());
      dispatch(
        getCurrentUserRegistered({
          user_id: getUserPublicId(),
          profile_id: getProfilePublicId(),
        })
      );
    }

    reset();
  };

  function reset() {
    dispatch(setQuizModal(false));
    dispatch(setPsychoQuizModal(false));
    setQuizData(null);
    setIndex(0);
    setLoading(false);
    setDisableQuizSubmit(true);
  }

  useEffect(() => {
    if (quizModal) getGenericQuiz();
    if (psychoQuizModal) getPsychoQuiz();
    localStorage.removeItem('answerData');
  }, [quizModal, psychoQuizModal]);

  const handleModalClose = () => {
    const quiz_modal = dispatch(setQuizModal(false));
    const psycho_quiz_modal = dispatch(setPsychoQuizModal(false));

    return quiz_modal || psycho_quiz_modal;
  };

  let submitClass =
    'font-semibold text-white bg-gray-300 px-[39.5px] py-[11px] rounded-[100px] ml-4';

  if (!disableQuizSubmit) {
    submitClass =
      'font-semibold text-white bg-black px-[39.5px] py-[11px] rounded-[100px] ml-4';
  }

  function getPercentage(index) {
    return Math.round((index / quizData?.length) * 100);
  }
  return (
    <Modal
      className='flex items-center justify-center overflow-scroll'
      open={quizModal || psychoQuizModal}
      onClose={handleModalClose}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
    >
      <div className='w-full rounded-[12px] border border-[#EBEBEB] bg-white p-4 sm:w-[600px] sm:p-8'>
        <div className='flex items-center justify-between'></div>

        <div>
          {(() => {
            if (quizData?.length && !loading) {
              return (
                <>
                  <div className='flex items-start justify-between'>
                    <h6 className='mb-4 text-[22px] font-semibold text-[#757575]'>
                      {lang?.common?.question} {index + 1}
                      <span className='text-[12px] font-normal text-[#616161]'>
                        /{quizData?.length}
                      </span>
                    </h6>
                    <span
                      onClick={handleCancel}
                      className='block cursor-pointer sm:hidden'
                    >
                      <MdClose size={20} />
                    </span>
                  </div>
                  <div className='relative h-[10px] w-full rounded-sm bg-[#EDEDED]'>
                    <div
                      style={{ width: `${getPercentage(index + 1)}%` }}
                      className='absolute h-[10px] rounded-sm bg-black'
                    ></div>
                  </div>
                  <div className='mt-4 w-full'>
                    <h3 className='mt-3 text-[18px] font-semibold'>
                      {quizData[index]?.title}
                    </h3>
                    <p className='mt-2 line-clamp-1 break-words text-sm text-[#616161]'>
                      {quizData[index]?.description}
                    </p>
                  </div>
                  <div className='mt-4'>
                    {quizData[index]?.options?.map((item) => (
                      <label
                        key={item?.option_id}
                        htmlFor={`quiz-${item?.option_id}`}
                        className='mt-3 flex cursor-pointer items-center gap-2 rounded-xl bg-[#F9F9F9] px-[17px] py-[16px]'
                      >
                        <input
                          className='accent-[var(--text-high)]'
                          onChange={onChange}
                          name='quiz'
                          value={item?.option_id}
                          id={`quiz-${item?.option_id}`}
                          type='radio'
                        />
                        {item?.option}
                      </label>
                    ))}
                  </div>
                  <div className='ml-[17px] mt-[32px] flex w-full justify-between'>
                    <button
                      onClick={handleCancel}
                      className='hidden font-semibold text-black sm:block'
                    >
                      {lang?.common?.cancel}
                    </button>

                    {showSubmit() ? (
                      <div className='mr-[16px] flex w-full justify-end sm:mr-0'>
                        {index > 0 && (
                          <button
                            className='ml-2 rounded-[100px] border-2 border-black px-[39.5px] py-[9px] font-semibold sm:ml-0'
                            onClick={handleBack}
                          >
                            {lang?.common?.back}
                          </button>
                        )}
                        <button onClick={handleSubmit} className={submitClass}>
                          <span>{lang?.common?.submit}</span>
                        </button>
                      </div>
                    ) : (
                      <div className='mr-[16px] flex w-full justify-end sm:mr-0'>
                        {index > 0 && (
                          <button
                            className='rounded-[100px] border-2 border-black px-[39.5px] py-[9px] font-semibold'
                            onClick={handleBack}
                          >
                            {lang?.common?.back}
                          </button>
                        )}
                        <button
                          onClick={updateIndex}
                          className='ml-4 rounded-[100px] bg-black px-[39.5px] py-[11px] font-semibold text-white'
                        >
                          <span>{lang?.common?.next}</span>
                        </button>
                      </div>
                    )}
                  </div>
                </>
              );
            } else if (loading && quizData === null) {
              return <Loader />;
            } else if (quizData?.length === 0 && !loading) {
              return (
                <div className='relative py-16'>
                  <MdClear
                    className='text-black-600 absolute left-[95%] top-0 z-10 h-[24px] w-[24px] cursor-pointer rounded-full border-2'
                    onClick={handleCancel}
                  />
                  <p className='mb-0 text-center text-xl font-bold'>
                    {lang?.common?.no_data_found}!
                  </p>
                </div>
              );
            }
          })()}
        </div>
      </div>
    </Modal>
  );
};

export default QuizModal;
